<template>
  <div class="main-container min-vh-100 w-100">
    <div class="close-container">
      <CButton @click="onClose">
        <font-awesome-icon :icon="['fas', 'times']" />
      </CButton>
    </div>
    <div ref="summary-container" class="summary-box mt-5">
      <canvas id="graph" width="6vh" height="6vh"></canvas>
    </div>
    <div class="text-center mb-5">
      <button class="btn btn-cpr btn-next" @click="onNext">
        {{ $helpers.translate(actionNext.title, lang) }}&nbsp;>>>
      </button>
    </div>
    <div class="cartoon-image-container">
      <img v-if="mascot" :src="mascot" />
    </div>
  </div>
</template>
<script src="path/to/chartjs/dist/Chart.js"></script>
<script>
import {mapGetters} from 'vuex';
import Chart from 'chart.js';
export default {
  name: 'Summaryall',
  data() {
    return {
      mascot: '',
      item: [],
      actionClose: '',
      actionNext: '',
      lang: 'th',
      content: [],
      progress: [],
      next: '',
      courseCode: '',
      templateId: '',
      startTime: '',
      courseSection: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
    };
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      else return value.toUpperCase();
    },
  },
  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
      // templateContent: 'template/getTemplateContent',
      getCourseProgress: 'courses/getCourseChapterAndProgress',
    }),
  },
  created() {
    this.courseCode = this.$store.getters['necessary/getLerningCourse']._id;
    this.startTime = this.$helpers.getDateFormat();
  },
  watch: {
    getCourseProgress: function (val) {
      this.progress = val;
      this.onSetPosition();
    },
    getTemplatev3(val) {
      console.log(val, 'gettemp');

      const template = val.templates[0];
      if (!template.enable) {
        this.$router.push({name: 'v4' + template.navigate.close.action});
      } else {
        var containerWidth = 0;
        this.courseSection = this.$store.getters['necessary/getLerningCourse'];
        this.mascot = this.baseUrl + '/cpr/Image/' + template.content.image;
        this.templateId = template._id;
        this.actionClose = template.navigate.close;
        this.actionNext = template.navigate.next;
        this.content = template.content;
        this.next = template.navigate.next.action;
        this.$store.dispatch(
          'courses/fetchCourseChapterAndProgress',
          this.courseSection
        );
        // this.$store.dispatch('template/createUserTemplateData', {
        //   code: this.courseCode,
        //   template: val._id,
        //   section: this.courseSection,
        // });
      }
    },
    // templateContent: function (val) {
    //   if (!val.enable) {
    //     this.$router.push({name: val.navigate.close.action});
    //   } else {
    //     var containerWidth = 0;
    //     this.courseSection =
    //       this.$store.getters['necessary/getLerningCourse'].groups[0].code;
    //     this.mascot = this.baseUrl + '/cpr/Image/' + val.content.image;
    //     this.templateId = val._id;
    //     this.actionClose = val.navigate.close;
    //     this.actionNext = val.navigate.next;
    //     this.content = val.content;
    //     this.next = val.navigate.next.action;
    //     this.$store.dispatch(
    //       'courses/fetchCourseChapterAndProgress',
    //       this.courseCode
    //     );
    //     this.$store.dispatch('template/createUserTemplateData', {
    //       code: this.courseCode,
    //       template: val._id,
    //       section: this.courseSection,
    //     });
    //   }
    // },
  },
  mounted() {
    // let body = {};
    // body.code = this.courseCode;
    // body.templateCode = 'CPR-E51';

    // this.$store.dispatch('template/fetchContent', body);

    const templateCode = 'CPR-E51';

    this.$store.dispatch('v3/fetchTemplateByCode', templateCode);
  },
  methods: {
    onNext() {
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseCode,
      //   template: this.templateId,
      //   section: this.courseSection,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: [],
      // });
      this.$router.push({
        name: 'v4' + this.next,
      });
    },
    onSetPosition() {
      var label = [];
      var data = [];
      if (this.progress.template.length > 0) {
        for (var i = 0; i < this.progress.template.length; i++) {
          if (this.progress.template[i].percent > 0) {
            label.push(
              this.$helpers.translate(
                this.progress.template[i].description,
                this.lang
              )
            );
            data.push(this.progress.template[i].score);
          }
        }
      }
      var ctx = document.getElementById('graph').getContext('2d');
      var myChart = new Chart(ctx, {
        type: 'radar',
        data: {
          labels: label,
          datasets: [
            {
              pointBackgroundColor: 'rgba(255, 204, 102, 0.2)',
              data: data,
              backgroundColor: ['rgba(255, 255, 255, 0.5)'],
              borderColor: ['rgb(56, 173, 174, 1)'],
              borderWidth: 3,
            },
          ],
        },
        options: {
          scale: {
            gridLines: {circular: true},
            pointLabels: {
              fontSize: 14,
              fontFamily: "'Kanit', sans-serif",
            },
            ticks: {
              suggestedMin: 0,
              suggestedMax: 100,
            },
          },

          point: {
            radius: 5,
          },
          legend: {
            display: false,
            labels: {
              padding: 10,
              fontColor: '#1d7af3',
              fontSize: 20,
            },
          },
        },
      });
    },
    onClose() {
      this.$router.push({
        name: 'v4' + this.actionClose.action,
      });
    },
  },
};
</script>
<style scoped>
@import '../../../assets/scss/CPR/style.scss';
.cancelMark {
  position: relative;
  width: 100%;
}
#graph {
  display: block;
  position: absolute;
  height: 100% !important;
  width: 100% !important;
  left: 50%;
  top: 50%;
  margin-top: -50%;
  margin-left: -50%;
}
.summary-box .dot {
  background: transparent
    linear-gradient(139deg, #d9d9d9 0%, var(--unnamed-color-e2e2e2) 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(139deg, #d9d9d9 0%, #e2e2e2 100%) 0%
    0% no-repeat padding-box;
  box-shadow: -2px -2px 5px #ffffff80;
  border: 1px solid #ffffff40;
  opacity: 0.8;
  position: absolute;
  top: 0;
  left: 0;
  width: 5vh;
  height: 5vh;
  border-radius: 50%;
}
.dot .dot-container {
  padding: 5px;
  margin-left: -10px;
}
.main-container .summary-box {
  text-align: center;
  padding: 0;
  position: relative;
  margin: 10% auto 0 auto !important;
  width: 60vh;
  height: 60vh;
  min-width: 400px;
  min-height: 400px;
}
.cartoon-image-container {
  position: absolute;
  left: 10%;
  top: 20%;
  width: 20rem;
  height: auto;
}
.cartoon-image-container img {
  object-fit: fill;
  width: 100%;
  height: 100%;
  max-width: auto;
  max-height: auto;
}
.option-container {
  position: absolute;
  width: 360px;
  height: 360px;
  top: 50%;
  left: 50%;
  margin-left: -180px;
  margin-top: -180px;
  text-align: center;
  border-radius: 20px;
  background-color: hsla(0, 0%, 92.2%, 0.3);
  -webkit-box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  opacity: 1;
  backdrop-filter: blur(10px);
}
.btn-control {
  background: #d9d9d9 0% 0% no-repeat padding-box;
  border-radius: 50%;
  box-shadow: -2px -2px 5px #ffffff80;
  left: 10rem;
  width: 45px;
  height: 45px;
  margin-right: 6rem;
}
.button-container {
  margin-top: 5.375rem;
  text-align: center;
}

.button-container .button {
  outline: none;
  padding: 1rem 3rem;
}
.close-container {
  text-align: center;
  position: absolute;
  top: 15%;
  right: 5%;
  z-index: 9;
  background: transparent
    linear-gradient(139deg, #d9d9d9 0%, var(--unnamed-color-e2e2e2) 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(139deg, #d9d9d9 0%, #e2e2e2 100%) 0%
    0% no-repeat padding-box;
  box-shadow: -2px -2px 5px #ffffff80;
  border: 1px solid #ffffff40;
  opacity: 0.8;
  border-radius: 50%;
}
.content-container {
  position: relative;
  height: 360px;
}
.chart-container {
  left: 5rem;
  border-radius: 20px;
  box-shadow: -2px -1px 5px 5px rgba(133, 132, 132, 0.2);
}
.main-container {
  overflow-y: hidden;
  overflow-x: hidden;
  padding-top: 3rem;
  left: 0px;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: auto;
  /* background: transparent linear-gradient(224deg, #ffffff00 0%, #00000038 100%)
    0% 0% no-repeat padding-box; */
  background: #f3f3f3;
}
.words-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.words-container .words-description {
  position: relative;
  font-size: 30px;
  font-weight: bold;
  font-family: Roboto;
  width: 100%;
  color: white;
  background: #00000000 0% 0% no-repeat padding-box;
  box-shadow: 3px 3px 3px #ffffff;
  border: 1px solid #ffffff;
  border-radius: 28px;
  opacity: 1;
  background: linear-gradient(
    270deg,
    rgba(169, 241, 223, 1) 2%,
    rgba(255, 136, 136, 1) 100%
  );
  border-radius: 50px;
  padding-left: 3rem;
}
@media screen and (max-width: 1440px) {
  .cartoon-image-container {
    left: 0;
    top: 10%;
  }
}
@media screen and (max-width: 768px) {
  .cartoon-image-container {
    left: -1rem;
    width: 12rem;
    height: 24rem;
  }
}
@media screen and (max-width: 480px) {
  .cartoon-image-container {
    position: absolute;
    left: -2rem;
    bottom: 0rem;
    width: 12rem;
    height: 20rem;
  }

  .main-container {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .main-container .summary-box {
    width: 100%;
    height: 100%;
  }
  .main-container .summary-box .cancel-mark {
    float: right;
    margin-right: -0.5rem;
    font-size: 1.35rem;
    margin-top: -1.75rem;
  }

  .main-container .summary-box .container-content {
    padding: 0px 0.75rem;
    margin-bottom: 3rem;
  }

  .main-container .summary-box .summary-title {
    font-size: 2rem;
    margin-bottom: 3rem;
  }

  .main-container .summary-box .status-circle-display {
    margin: auto;
    width: 4.375rem;
    height: 4.375rem;
    border-radius: 50%;
  }
}
</style>
